import React from 'react';
import { useNavigate } from 'react-router-dom';

const LoginPromptModal = ({ onClose }) => {
    const navigate = useNavigate();

    const handleLoginRedirect = () => {
        navigate('/login');
    };

    const handleBackgroundClick = (event) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="modal" onClick={handleBackgroundClick}>
            <div className="modal-content">
                <h3>ログインが必要です</h3>
                <p>保存機能を利用するには、アカウント登録・ログインが必要です。</p>
                <button onClick={handleLoginRedirect} className="bg-blue">
                    ログインページへ
                </button>
                <button onClick={onClose} className="bg-gray">
                    キャンセル
                </button>
            </div>
        </div>
    );
};

export default LoginPromptModal;